// cart.js
// Function to update cart button states based on current cart contents
function updateCartButtonStates() {
  const cart = JSON.parse(localStorage.getItem('cart') || '[]');
  const cartItemIds = cart.map(item => String(item.id));

  // Update all add/remove cart buttons
  $('.add-to-cart, .remove-from-cart').each(function () {
    const $button = $(this);
    const postId = $button.data('id');
    const isInCart = cartItemIds.includes(String(postId));

    if ($button.hasClass('add-to-cart')) {
      $button.toggle(!isInCart);
    } else if ($button.hasClass('remove-from-cart')) {
      $button.toggle(isInCart);
    }
  });
}

// Wait for both DOM and jQuery to be ready
jQuery(document).ready(function ($) {
  // Initialize cart in localStorage if it doesn't exist
  if (!localStorage.getItem('cart')) {
    localStorage.setItem('cart', JSON.stringify([]));
  }

  // Initialize currentOrder in localStorage if it doesn't exist
  if (!localStorage.getItem('currentOrder')) {
    localStorage.setItem('currentOrder', JSON.stringify([]));
  }

  // Update cart button states on page load
  updateCartButtonStates();

  // Initialize quantity controls with event delegation
  $(document)
    .off('click', '.quantity-btn')
    .on('click', '.quantity-btn', function (e) {
      e.stopPropagation();
      e.preventDefault();

      const $button = $(this);
      const $item = $button.closest('.item');
      const $input = $button.siblings('input.quantity-input');
      let value = parseInt($input.val()) || 1;
      const maxQuantity = parseInt($item.attr('data-max-quantity')) || 0;

      if ($button.hasClass('plus')) {
        // Check max quantity limit BEFORE incrementing (0 means unlimited)
        if (maxQuantity > 0 && value >= maxQuantity) {
          alert('Quantité maximale atteinte: ' + maxQuantity);
          return false;
        }
        value++;
      } else if ($button.hasClass('minus') && value > 1) {
        value--;
      }

      $input.val(value).trigger('change');
    });

  // Handle direct input changes with debounce
  let quantityTimeout;
  $(document)
    .off('change', '.quantity-input')
    .on('change', '.quantity-input', function () {
      const $input = $(this);
      const $item = $input.closest('.item');
      let value = parseInt($input.val()) || 1;
      const maxQuantity = parseInt($item.attr('data-max-quantity')) || 0;

      // Ensure value is at least 1
      value = Math.max(1, value);

      // Check max quantity limit (0 means unlimited)
      if (maxQuantity > 0 && value > maxQuantity) {
        value = maxQuantity;
        alert('Quantité maximale atteinte: ' + maxQuantity);
      }

      $input.val(value);

      // Update the cart item with new quantity
      if ($item.length) {
        // Debounce the update to prevent multiple rapid updates
        clearTimeout(quantityTimeout);
        quantityTimeout = setTimeout(() => {
          updateCartItem($item, value);
        }, 300);
      }
    });

  // Handle add to cart
  $(document)
    .off('click', '.add-to-cart')
    .on('click', '.add-to-cart', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $button = $(this);
      const postId = $button.data('id');

      // Get current cart or initialize empty array
      let cart = JSON.parse(localStorage.getItem('cart') || '[]');

      // Check if item already in cart
      const itemIndex = cart.findIndex(item => String(item.id) === String(postId));

      if (itemIndex === -1) {
        // Add new item to cart
        cart.push({
          id: postId,
          quantity: 1,
        });

        // Save to localStorage
        localStorage.setItem('cart', JSON.stringify(cart));

        // Update UI
        $button.hide();
        $button.siblings('.remove-from-cart').show();

        // Update cart count
        updateCartCount(cart.reduce((sum, item) => sum + (item.quantity || 1), 0));

        // Show feedback
        var toast = $('<div class="toast">Ajouté au panier</div>');
        $('body').append(toast);
        setTimeout(() => toast.remove(), 2000);
      }
    });

  // Handle remove from cart
  $(document)
    .off('click', '.remove-from-cart')
    .on('click', '.remove-from-cart', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $button = $(this);
      const postId = $button.data('id');

      // Get current cart
      let cart = JSON.parse(localStorage.getItem('cart') || '[]');

      // Remove item from cart
      cart = cart.filter(item => String(item.id) !== String(postId));

      // Save updated cart
      localStorage.setItem('cart', JSON.stringify(cart));

      // Update UI
      $button.hide();
      $button.siblings('.add-to-cart').show();

      // Update cart count
      updateCartCount(cart.reduce((sum, item) => sum + (item.quantity || 1), 0));

      // If on cart page, remove the item from the DOM
      if ($('.cart-items').length) {
        $button.closest('.item').fadeOut(300, function () {
          $(this).remove();
          // Update cart total if function exists
          if (typeof updateCartTotal === 'function') {
            updateCartTotal();
          }
        });
      }
    });

  // Handle "Commander cet article" (Order this item)
  $(document)
    .off('click', '.order-item-btn')
    .on('click', '.order-item-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $item = $(this).closest('.item');
      const postId = $item.data('post-id');
      const quantity = parseInt($item.find('.quantity-input').val()) || 1;

      // Create order with current item
      const order = [
        {
          id: postId,
          quantity: quantity,
        },
      ];

      try {
        // Store in currentOrder
        localStorage.setItem('currentOrder', JSON.stringify(order));

        // Redirect to checkout
        window.location.href = '/commander';
      } catch (error) {
        console.error('Error saving order:', error);
        alert('Une erreur est survenue lors de la commande. Veuillez réessayer.');
      }
    });

  // Handle "Commander tout le panier" (Order all cart)
  $(document)
    .off('click', '.order-all-btn')
    .on('click', '.order-all-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Get current cart
      let cart = JSON.parse(localStorage.getItem('cart') || '[]');

      if (cart.length === 0) {
        alert('Veuillez sélectionner au moins un article à commander');
        return;
      }

      // Update quantities from the current page
      const updatedCart = [];
      $('.item').each(function () {
        const $item = $(this);
        const postId = $item.data('post-id');

        // Only process items that are in the cart
        const existingItem = cart.find(item => String(item.id) === String(postId));
        if (existingItem) {
          const quantity = parseInt($item.find('.quantity-input').val()) || 1;
          existingItem.quantity = quantity;
          updatedCart.push(existingItem);
        }
      });

      try {
        // Save to both currentOrder and cart for backward compatibility
        localStorage.setItem('currentOrder', JSON.stringify(updatedCart));
        localStorage.setItem('cart', JSON.stringify(updatedCart));

        // Redirect to checkout
        window.location.href = '/commander';
      } catch (error) {
        console.error('Error saving order:', error);
        alert('Une erreur est survenue lors de la commande. Veuillez réessayer.');
      }
    });

  // Update cart item quantity in localStorage
  function updateCartItem($item, quantity) {
    const postId = $item.data('post-id') || $item.closest('[data-post-id]').data('post-id');
    let cart = JSON.parse(localStorage.getItem('cart') || '[]');

    // Find if item exists in cart
    const itemIndex = cart.findIndex(item => String(item.id) === String(postId));

    if (itemIndex !== -1) {
      // Update existing item quantity
      cart[itemIndex].quantity = quantity;
    } else {
      // Add new item to cart
      cart.push({
        id: postId,
        quantity: quantity,
      });
    }

    // Save the updated cart
    localStorage.setItem('cart', JSON.stringify(cart));

    // Update cart count
    updateCartCount(cart.reduce((sum, item) => sum + (item.quantity || 1), 0));

    // Update server cart if function exists
    if (typeof updateServerCart === 'function') {
      updateServerCart(cart);
    }

    // Update cart total if function exists
    if (typeof window.updateCartTotal === 'function') {
      window.updateCartTotal();
    }
  }

  // Update server cart
  function updateServerCart(cart) {
    $.ajax({
      url: agiflyAjax.ajax_url,
      type: 'POST',
      data: {
        action: 'update_cart',
        nonce: agiflyAjax.nonce,
        cart: cart,
      },
      success: function (response) {
        console.log('Cart updated on server');
      },
      error: function (error) {
        console.error('Error updating cart on server', error);
      },
    });
  }

  // Update cart count in the UI
  function updateCartCount(count) {
    $('.cart-count').text(count);
  }

  // Function to update cart button states based on cart contents
  function updateCartButtonStates() {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');

    // Reset all buttons to default state first
    $('.add-to-cart').show();
    $('.remove-from-cart').hide();

    // Update buttons for each cart item
    cart.forEach(item => {
      // Ensure id is treated as a string for comparison
      const idStr = String(item.id);

      // Update buttons for this item
      $(`.add-to-cart[data-id="${idStr}"]`).hide();
      $(`.remove-from-cart[data-id="${idStr}"]`).show();
    });
  }

  // Update cart button states after AJAX content loads
  $(document).ajaxComplete(function () {
    updateCartButtonStates();
  });

  // Function to display checkout cart items via AJAX
  function updateCheckoutCart() {
    const $checkoutCartItems = $('.for-cart .checkout-cart-items');
    if ($checkoutCartItems.length === 0) return;

    // Show loading state
    $checkoutCartItems.html('<div class="loading"><img src="' + theme_vars.template_directory + '/assets/images/icons/loading.svg" alt="Loading..."></div>');

    // Get the current order from localStorage
    const currentOrder = JSON.parse(localStorage.getItem('currentOrder') || '[]');

    // If cart is empty, show empty message
    if (currentOrder.length === 0) {
      $checkoutCartItems.html('<p class="empty-cart"><span class="empty-cart-icon">🛒</span> Votre panier est vide</p>');
      return;
    }

    // Get cart items via AJAX using the new endpoint
    $.ajax({
      url: agiflyAjax.ajax_url,
      type: 'POST',
      data: {
        action: 'get_checkout_cart',
        nonce: agiflyAjax.nonce,
        cart_items: JSON.stringify(currentOrder),
      },
      success: function (response) {
        if (response.success && response.data && response.data.html) {
          $checkoutCartItems.html(response.data.html);
        } else {
          $checkoutCartItems.html('<p>Erreur lors du chargement du panier</p>');
          console.error('Error in cart response:', response);
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX Error:', status, error);
        $checkoutCartItems.html('<p>Erreur de connexion au serveur</p>');
      },
    });
  }

  // Update checkout cart on page load and when cart is updated
  updateCheckoutCart();

  // Also update when cart is modified
  $(document).on('cartUpdated', function () {
    updateCheckoutCart();
  });

  // Handle checkout form submission
  $('#checkout-form').on('submit', function (e) {
    e.preventDefault();

    // Reset previous errors
    $('.error-message').hide().text('');

    // Collect form data
    const $form = $(this);
    const formData = $form.serializeArray();
    const formObject = {};
    formData.forEach(function (item) {
      formObject[item.name] = item.value;
    });

    // Get cart from localStorage
    const currentOrder = JSON.parse(localStorage.getItem('currentOrder') || '[]');

    // Validation rules
    const requiredFields = [
      { id: 'name', message: 'Ce champ est obligatoire.' },
      { id: 'first_name', message: 'Ce champ est obligatoire.' },
      { id: 'school_name', message: 'Ce champ est obligatoire.' },
      {
        id: 'email',
        message: 'Ce champ est obligatoire.',
        validate: function (val) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
        },
        invalidMessage: 'Veuillez saisir une adresse email valide.',
      },
      {
        id: 'phone',
        message: 'Ce champ est obligatoire.',
        validate: function (val) {
          const cleaned = val.replace(/[\s\-\(\)]/g, '');
          return cleaned.length >= 10 && /^\d+$/.test(cleaned);
        },
        invalidMessage: 'Veuillez saisir un numéro de téléphone valide (au moins 10 chiffres).',
      },
      { id: 'address', message: 'Ce champ est obligatoire.' },
      { id: 'number', message: 'Ce champ est obligatoire.' },
      { id: 'zip_code', message: 'Ce champ est obligatoire.' },
      { id: 'city', message: 'Ce champ est obligatoire.' },
      {
        id: 'terms_conditions',
        message: 'Veuvez accepter les conditions générales pour continuer.',
        validate: function (val, $input) {
          return $input.is(':checked');
        },
        invalidMessage: 'Vous devez accepter les conditions générales pour continuer.',
      },
    ];

    let isValid = true;

    // Check each required field
    requiredFields.forEach(function (field) {
      const $input = $('#' + field.id);
      const value = $input.val().trim();

      if (!value) {
        showError($input, field.message);
        isValid = false;
        return;
      }

      // Additional validation for fields with custom validation
      if (field.validate) {
        const isValidField = field.id === 'terms_conditions' ? field.validate(value, $input) : field.validate(value);

        if (!isValidField) {
          showError($input, field.invalidMessage || field.message);
          isValid = false;
          return;
        }
      }
    });

    // Check if cart is empty
    if (currentOrder.length === 0) {
      alert('Le panier est vide. Veuillez ajouter au moins un article.');
      isValid = false;
    }

    if (!isValid) {
      // Scroll to first error
      const firstError = $('.error-message:visible').first();
      if (firstError.length) {
        $('html, body').animate(
          {
            scrollTop: firstError.offset().top - 100,
          },
          500
        );
      }
      return;
    }

    // Show loading
    const $button = $form.find('.order-btn');
    const originalText = $button.text();
    $button.prop('disabled', true).text('Envoi en cours...');

    $.ajax({
      url: agiflyAjax.ajax_url,
      type: 'POST',
      data: {
        action: 'submit_order',
        checkout_nonce_field: $form.find('[name="checkout_nonce_field"]').val(),
        ...formObject,
        cart_items: JSON.stringify(currentOrder),
      },
      success: function (response) {
        if (response.success) {
          // Clear cart
          localStorage.removeItem('currentOrder');
          localStorage.removeItem('cart');
          localStorage.removeItem('cartItems');
          // Redirect to confirmation page with secure token instead of order_id
          window.location.href = window.location.origin + '/confirmation/?token=' + response.data.order_token;
        } else {
          alert('Erreur: ' + (response.data || 'Une erreur est survenue.'));
          $button.prop('disabled', false).text(originalText);
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX Error:', status, error);
        alert('Erreur de connexion au serveur.');
        $button.prop('disabled', false).text(originalText);
      },
    });
  });

  // Helper function to show error message below a field
  function showError($input, message) {
    const $errorDiv = $input.siblings('.error-message');
    $errorDiv.text(message).show();
    $input.addClass('error'); // Optional: add error class for styling
  }

  // Helper function to hide error message
  function hideError($input) {
    const $errorDiv = $input.siblings('.error-message');
    $errorDiv.hide().text('');
    $input.removeClass('error');
  }

  // Real-time validation on blur for required fields
  const requiredInputIds = ['name', 'first_name', 'school_name', 'email', 'phone', 'address', 'number', 'zip_code', 'city'];
  $(document).on('blur', function (e) {
    if (requiredInputIds.includes(e.target.id)) {
      const $input = $(e.target);
      const value = $input.val().trim();
      let message = 'Ce champ est obligatoire.';
      let isValid = value !== '';

      const fieldName = $input.attr('name');
      if (fieldName === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        isValid = emailRegex.test(value);
        message = isValid ? '' : 'Veuillez saisir une adresse email valide.';
      } else if (fieldName === 'phone') {
        const cleaned = value.replace(/[\s\-\(\)]/g, '');
        isValid = cleaned.length >= 10 && /^\d+$/.test(cleaned);
        message = isValid ? '' : 'Veuillez saisir un numéro de téléphone valide (au moins 10 chiffres).';
      } else if (fieldName === 'zip_code') {
        isValid = /^\d{4,5}$/.test(value.replace(/\s/g, '')); // Basic zip code validation (e.g., 4-5 digits)
        message = isValid ? '' : 'Veuillez saisir un code postal valide.';
      }

      if (!isValid) {
        showError($input, message);
      } else {
        hideError($input);
      }
    }
  });

  // Clear error on input focus or keyup for required fields
  $(document).on('focus keyup', function (e) {
    if (requiredInputIds.includes(e.target.id)) {
      const $input = $(e.target);
      const value = $input.val().trim();
      if (value !== '') {
        hideError($input);
      }
    }
  });

  // Call updateCartButtonStates when the page loads
  updateCartButtonStates();

  // Function to update cart UI based on cart items
  function updateCartUI() {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const $cartContainer = $('.cart-items');

    // Hide cart content and show loader
    if ($cartContainer.length) {
      $cartContainer.prepend('<div class="loading"><img src="' + theme_vars.template_directory + '/assets/images/icons/loading.svg" alt="Loading..."></div>');
    }

    // Simulate AJAX call with a small delay
    setTimeout(() => {
      // Reset all buttons to default state first
      $('.add-to-cart').show();
      $('.remove-from-cart').hide();

      // Update UI for each cart item
      cart.forEach(item => {
        // Ensure id is treated as a string for comparison
        const idStr = String(item.id);

        // Update buttons for this item
        $(`.add-to-cart[data-id="${idStr}"]`).hide();
        $(`.remove-from-cart[data-id="${idStr}"]`).show();

        // Update quantity input if it exists
        $(`.item[data-post-id="${idStr}"] .quantity-input`).val(item.quantity);
      });

      // Update cart count
      updateCartCount(cart.reduce((sum, item) => sum + (item.quantity || 1), 0));

      // Update cart total if function exists
      if (typeof window.updateCartTotal === 'function') {
        window.updateCartTotal();
      }

      // Remove loading state and show content
      if ($cartContainer.length) {
        $cartContainer.find('.loading').remove();
        $cartContainer.removeClass('loading-state');
      }
    }, 500);
  }
});
